import { baseInputTheme } from '../BaseInput/theme'

export const textareaTheme = {
  ...baseInputTheme,
  height: '--medkit-textarea-height',
}
